import { StyledChip } from "./styles";

export const Chip = StyledChip;
